// @ts-ignore untyped module
import formatBusinessUnitDropdownOptions from 'reference-resolvers/formatters/formatBusinessUnitDropdownOptions';
import { getBusinessUnitDisplaysForUserRpc } from '../../__generated__/chirp/com/hubspot/business/units/rpc/BusinessUnitsDisplaysService';
import { rpcClient } from './rpcClient';
export const createGetBusinessUnitDisplaysForUser = ({
  httpClient
}) => () => httpClient.call(getBusinessUnitDisplaysForUserRpc, {}).then(({
  businessUnitDisplays
}) => formatBusinessUnitDropdownOptions(businessUnitDisplays));
export const getBusinessUnitDisplaysForUser = createGetBusinessUnitDisplaysForUser({
  httpClient: rpcClient
});